import React from "react";
import clsx from "clsx";
import ProductBuilderErrors from "./ProductBuilderErrors";
import ProductDetails from "./ProductDetails";
import UploadGroupBuilder from "../UploadGroupBuilder/UploadGroupBuilder";
import List from "../List/List";
import MultiSelect from "../Selects/MultiSelect"

import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { parseISO } from 'date-fns';


class ProductBuilder extends React.Component {

  constructor(props) {
    super(props);

    let product = this.props.product
    if (product && product.start_date && product.end_date) {
      product.start_date = parseISO(product.start_date)
      product.end_date = parseISO(product.end_date)
    } else if ( product && product.start_date) {
      product.start_date = parseISO(product.start_date)
    } else if (product && product.end_date) {
      product.end_date = parseISO(product.end_date)
    }


    this.state = {
      errors: [],
      success: null,
      loading: false,
      activeTab: 'general',
      mode: typeof this.props.mode !== 'undefined' ? this.props.mode : 'multiple',
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      remove: typeof this.props.remove !== 'undefined' ? this.props.remove : true,
      tabs: typeof this.props.tabs !== 'undefined' ? this.props.tabs : false,
      product: product ? product : {},
      note_count: this.props.product && this.props.product.note_count || null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      image_group: this.props.product ? this.props.product.image_group : null,
      menu_item: "products_and_services",
      image_group_ids: this.props.product && this.props.product.image_group ? this.props.product.image_group.images.map((image) => {return image.id}) : [],
      taxes: this.props.taxes && this.props.taxes.length
      ? this.props.taxes.map(tax => tax.id)
      : [],
      fees: this.props.fees && this.props.fees.length
      ? this.props.fees.map(fee => fee.id)
      : [],
      room_types: this.props.product && this.props.product.room_types && this.props.product.room_types.length
      ? this.props.product.room_types.map(room_type => room_type.id)
      : [],

    };
    this.renderFieldErrors = this.renderFieldErrors.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.onChangeTax = this.onChangeTax.bind(this);
    this.onChangeRoomTypes = this.onChangeRoomTypes.bind(this);
    this.onChangeFee = this.onChangeFee.bind(this);
    this.addProduct = this.addProduct.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.onChange = this.onChange.bind(this);
    this.renderFieldClasses = this.renderFieldClasses.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.onChangeSwitch = this.onChangeSwitch.bind(this);
    this.save = this.save.bind(this);
    this.onChangeNote = this.onChangeNote.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this);
    this.onChangeImageGroup = this.onChangeImageGroup.bind(this);
    this.updateNoteCount = this.updateNoteCount.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.onChangeInstructions = this.onChangeInstructions.bind(this);
    this.onChangeOrder = this.onChangeOrder.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeMinimumLead = this.onChangeMinimumLead.bind(this);
    this.onChangeMaximumLead = this.onChangeMaximumLead.bind(this);
  };

  componentDidUpdate() {
    if (typeof initTypeahead == 'function' && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    };
  };

  render() {
    if (this.state.tabs) {
      var generalTabClasses = clsx({
        'active': this.state.activeTab == 'general',
        'tab-pane': true
      });

      var roomTypesTabClasses = clsx({
        'active': this.state.activeTab == 'room_types',
        'tab-pane': true
      })

      var taxesTabClasses = clsx({
        'active': this.state.activeTab == 'taxes',
        'tab-pane': true
      })

      var imagesTabClasses = clsx({
        'active': this.state.activeTab == 'images',
        'tab-pane': true
      })

      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          onClick: (e) => {
            if (!this.props.new_product) {
              this.update()
            } else{
              this.save();
            }
          }
        }
      ];

      return (
        <div>
          <Tabs tabs={this.tabs()} displayErrorMessage={ProductBuilderErrors.general(this.state.errors).length ? true : false} />
          {this.renderSuccess()}
          <div ref="root" className="panel panel-form">
            <div className="tab-content">
              <div className={generalTabClasses}>
                {this.renderErrors()}
                {this.renderProductForm()}
              </div>
              <div className={roomTypesTabClasses}>
                {this.renderRoomTypesForm()}
              </div>
              <div className={taxesTabClasses}>
                {this.renderTaxesForm()}
              </div>
              <div className={imagesTabClasses}>
                {this.renderImagesForm()}
              </div>
            </div>
            <ModalButtons loading={this.state.loading} buttons={buttons} />
            <LoadingSpinner show={this.state.loading} />
          </div>
        </div>
      );
    } else {
      return (
        <div ref="root">
          {this.renderProductForm()}
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <LoadingSpinner show={this.state.loading} />
        </div>
      );
    };
  };

  renderSuccess() {
    if (this.state.success) {
      return <div className="alert-success">{this.state.success}</div>
    } else {
      return null;
    };
  };

  renderErrors() {
    var errors = ProductBuilderErrors.general(this.state.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.state.errors && this.state.errors.header_errors && this.state.errors.header_errors[field]) {
      var idx = 0;
      var errors = this.state.errors.header_errors[field].map((error) => {
        idx = idx + 1;
        if (field == 'frequency' || field == 'receipt_location') {
          return <li key={idx}><b>&#x2022;</b> {I18n.t('cant_be_blank')}</li>;
        }
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.state.errors && this.state.errors.header_errors && this.state.errors.header_errors[field]) {
      classname = classname + ' has-errors';
    };
    return classname;
  };

  renderImagesForm() {
    return (
      <div className="row">
        <div className="col-md-12">
          <UploadGroupBuilder upload_type="image" upload_type_plural="images" upload_groups={this.state.image_group ? [this.state.image_group] : [{ images: [] }]} onChange={this.onImageChange} data_table_path={this.props.images_data_table_path} multiple={true} read_only={this.props.read_only} helperText={"images_helper_text"} onChangeOrder={this.onChangeOrder} filterSize={false}/>
        </div>
      </div>
    );
  }

  renderProductForm() {
    return (
      <div className={"products " + this.state.mode} ref="root">
        <ProductDetails
          {...this.state}
          dateFormat={this.props.date_format}
          default_assigned_to={this.props.default_assigned_to ? this.props.default_assigned_to[0] : null}
          collapseDetails={this.props.collapseDetails}
          inputName={this.inputName}
          renderFieldErrors={this.renderFieldErrors}
          renderFieldClasses={this.renderFieldClasses}
          removeProduct={this.removeProduct}
          onChange={this.onChange}
          read_only={this.props.read_only}
          scheduled_at={this.props.scheduled_at}
          date_format={this.props.date_format}
          serviceRequest={this.props.serviceRequest}
          reservation_segment={this.props.reservation_segment}
          onChangeReccurringDate={this.props.onChangeReccurringDate}
          onChangeInput={this.onChangeInput}
          onChangeSwitch={this.onChangeSwitch}
          onChangeStatus={this.onChangeStatus}
          onChangeInstructions={this.onChangeInstructions}
          onChangeRoomTypes={this.onChangeRoomTypes}
          onChangeMinimumLead={this.onChangeMinimumLead}
          onChangeMaximumLead={this.onChangeMaximumLead}
          onChangeStartDate={this.onChangeStartDate}
          onChangeEndDate={this.onChangeEndDate}
        />
      </div>
    );
  };

  renderRoomTypesForm() {
    // var tabClasses = clsx({
    //   'active': this.props.active_tab == 'products',
    //   'tab-pane': true
    // })
    // console.log("this.props.all_room_types", this.props.all_room_types);
    var inputs = this.props.all_room_types.map(room_type => {
      return {
        label_primary: room_type.code,
        label_secondary: room_type.name,
        id: room_type.id,
        status: (room_type.status == "enabled" ? null : "disabled"),
      }
    })
    return (
      <div id="room_types">
        <div className="row">
          <div className="col-md-12">
          { inputs.length
          ?
            <MultiSelect
              header_primary="code"
              header_secondary="name"
              inputs={inputs}
              selected_inputs={this.state.room_types}
              onChange={this.onChangeRoomTypes}/>
          :
            <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
          }
          </div>
        </div>
      </div>
    )
  }


  renderTaxesForm() {
    if (this.state.product) {
      var product = this.state.product;
    } else {
      return;
    };

    return(
      <div  id="taxes">
        <div className="row">
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body">

                <h3 className="panel-heading-text">{I18n.t("taxes")}</h3>
                <div className="row">
                  <div className="col-md-12">
                    { product.taxes && product.taxes.length
                    ?
                      <List
                        header_primary="name"
                        items={product.taxes}
                        display_column_primary={"name"}
                        />
                    :
                      <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                    }
                  </div>
                </div>

              </div>
            </div>

          </div>
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body">
                <h3 className="panel-heading-text">{I18n.t("fees")}</h3>
                <div className="row">
                  <div className="col-md-12">
                    { product.fees && product.fees.length
                    ?
                    <List
                      header_primary="name"
                      items={product.fees}
                      display_column_primary={"name"}
                      />
                    :
                      <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="row">
          <div className="col-md-12" >
            <div style={{color: 'red', fontStyle: 'italic'}}>{I18n.t('tax_and_fee_directions')}</div>
          </div>

        </div>
      </div>
    )
  }

  setActiveTab(name) {
    this.setState({ activeTab: name });
  };

  addProduct(product) {
    var products = this.state.products.slice(0);

    if (products.indexOf(product) == -1) {
      products.unshift(product);
    };

    this.setState({ products: products }, () => {
      if (typeof this.props.onChange == 'function') {
        this.props.onChange(products);
      }
    });
  };

  removeProduct(idx) {
    var products = this.state.products.slice(0);
    products.splice(idx, 1);
    this.setState({ products: products }, () => {
      if (typeof this.props.onChange == 'function') {
        this.props.onChange(products);
      };
    });
  };

  onChangeImageGroup(image_group) {
    this.setState({image_group: image_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  updateNoteCount(count) {
    this.setState({
      note_count: count,
    })
  }

  onImageChange(image_group) {
    var image_group_ids = image_group.images.map(image => image.id)
    if(image_group) {
      this.setState({
        image_group_ids: image_group_ids,
        image_group: image_group
      })
    } else {
      this.setState({
        image_group_ids: null,
        image_group: null
      })
    }
  }

  onChangeOrder(idsInOrder) {
    this.setState({image_group_ids:idsInOrder})
  }

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event
    this.setState({note_obj: note_obj});
  }

  onChangeRoomTypes(room_types) {
    this.setState({room_types: room_types})
  }

  onChangeTax(taxes, event) {
    var product = this.state.product;
    product.tax_ids = taxes
    this.forceUpdate();
  };

  onChangeFee(fees, event) {
    var product = this.state.product;
    product.fee_ids = fees
    this.forceUpdate()
  }

  onChange(value, name) {
    this.setState({
      [name]: value,
    });
  };

  onChangeMinimumLead(event) {
    var product = this.state.product
    if (event && event.target) {
      product.minimum_lead = event.target.value
      this.setState({
        product: product
      })
    }
  }

  onChangeMaximumLead(event) {
    var product = this.state.product
    if (event && event.target) {
      product.maximum_lead = event.target.value
      this.setState({
        product: product
      })
    }
  }

  onChangeStartDate(date) {
    var product = this.state.product
    product.start_date = date
    this.setState({
      product: product
    })
  };

  onChangeEndDate(date) {
    var product = this.state.product
    product.end_date = date
    this.setState({
      product: product
    })
  };

  onChangeStatus(event) {
    var product = this.state.product
    if (event && event.target) {
      product.status = event.target.value
      this.forceUpdate()
    }
  }

  onChangeInstructions(event) {
    var product = this.state.product
    product.special_instructions = event.target.value
    this.setState({product: product})
  }

  onChangeSwitch(name, value) {
    // console.log("onChangeSwitch name, value", name, value);
    let updatedProduct = Object.assign({ ...this.state.product, [name]: value });
    // console.log("updatedProduct", updatedProduct);
    this.onChange(updatedProduct, 'product');
  };

  onChangeInput(e, name) {
    let updatedProduct = Object.assign({ ...this.state.product, [name]: e.target.value});
    this.onChange(updatedProduct, 'product');
  };





  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: ProductBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('room_types'),
          targetName: 'room_types',
          classes: this.state.activeTab === 'room_types' ? 'active' : null,
          changeHandler: this.setActiveTab,
          // tabErrorCount: ProductBuilderErrors.room_types(this.state.errors).length
        },
        {
          tabName: I18n.t('images'),
          targetName: 'images',
          classes: this.state.activeTab === 'images' ? 'active' : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t('taxes_and_fees'),
          targetName: 'taxes',
          classes: this.state.activeTab === 'taxes' ? 'active' : null,
          changeHandler: this.setActiveTab,
        }
      ]
    );

  };

  update() {
    this.setState({ loading: true });

    $.ajax({
      type: 'PATCH',
      url: `/admin/products/${this.state.product.id}`,
      data: {
        product:
        {
          code: this.state.product.code,
          name: this.state.product.name,
          description: this.state.product.description,
          start_date: this.state.product.start_date,
          end_date: this.state.product.end_date,
          minimum_lead: this.state.product.minimum_lead,
          maximum_lead: this.state.product.maximum_lead,
          amount: this.state.product.amount,
          show_as_booking_add_on: this.state.product.show_as_booking_add_on,
          show_in_customer_portal: this.state.product.show_in_customer_portal,
          quantity_allowed: this.state.product.quantity_allowed,
          collect_amount_at_booking: this.state.product.collect_amount_at_booking,
          portal_quantity_allowed: this.state.product.portal_quantity_allowed,
          status: this.state.product.status,
          requires_service_request: this.state.product.requires_service_request,
          default_assigned_to: this.state.product.default_assigned_to ? this.state.product.default_assigned_to.id : null,
          taxes: this.state.product.tax_ids ? this.state.product.tax_ids : null,
          fees: this.state.product.fee_ids ? this.state.product.fee_ids : null,
          special_instructions: this.state.product.special_instructions,
          updated_at: new Date(),
        },
        room_types: this.state.room_types,
        image_group_ids: this.state.image_group_ids,
        image_group_id: this.state.image_group && this.state.image_group.id ? this.state.image_group.id : null,
      },
    }).done((data) => {
      if (data.errors) {
        this.setState({ errors: data, success: null, loading: false });
      } else if (data.success) {
        this.setState({ errors: null, success: I18n.t('product_saved_successfully'), loading: false }, () => {
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
          window.handleAlertSuccess();
        });
      };
    });
  };

  save() {

    this.setState({ loading: true });
    $.ajax({
      type: 'POST',
      url: '/admin/products',
      data: {
          product: {
            code: this.state.product.code,
            name: this.state.product.name,
            description: this.state.product.description,
            amount: this.state.product.amount,
            status: this.state.product.status,
            start_date: this.state.product.start_date,
            end_date: this.state.product.end_date,
            minimum_lead: this.state.product.minimum_lead,
            maximum_lead: this.state.product.maximum_lead,
            show_as_booking_add_on: this.state.product.show_as_booking_add_on,
            show_in_customer_portal: this.state.product.show_in_customer_portal,
            quantity_allowed: this.state.product.quantity_allowed,
            collect_amount_at_booking: this.state.product.collect_amount_at_booking,
            requires_service_request: this.state.product.requires_service_request,
            default_assigned_to: this.state.product.default_assigned_to ? this.state.product.default_assigned_to.id : null,
            tax_ids: this.state.product.tax_ids ? this.state.product.tax_ids : null,
            fee_ids: this.state.product.fee_ids ? this.state.product.fee_ids : null,
            special_instructions: this.state.product.special_instructions,
          },
          room_types: this.state.room_types,
          image_group_ids: this.state.image_group_ids,
          image_group_id: this.state.image_group && this.state.image_group.id ? this.state.image_group.id : null,

      },
    }).done((data) => {
      if (data.errors) {
        this.setState({ errors: data, success: null, loading: false });
      } else if (data.success) {
        this.setState({ errors: null, success: I18n.t('product_created_successfully'), loading: false }, () => {
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
          window.handleAlertSuccess();
        });
      };
    });
  };

};

export default ProductBuilder
